import React, { useState } from 'react';
import {
  Title,
  Grid,
  Col,
  InputContainer,
  Input,
  Card,
  CardHeader,
  CardContent,
  Icon,
  Button,
  CheckboxContainer,
  RSelect,
} from '@common/components';
import {
  faEnvelope,
  faEye,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons';
import inputClasses from './InputSampleView.module.scss';

export default function InputSampleView() {
  const [emailFocus, setEmailFocus] = useState();
  const [emailFocus2, setEmailFocus2] = useState();
  const [passwordVisible, setPaswordVisible] = useState();
  const [privacy, setPrivacy] = useState(false);
  const [pepe, setPepe] = useState(false);
  const colourOptions = [
    { value: '7days', label: 'Last 7 days' },
    { value: 'month', label: 'Last month' },
  ];
  return (
    <div className={inputClasses.grid}>
      <Title type="h1">Input demo</Title>
      <Card className={inputClasses.section}>
        <CardHeader>
          <Title type="h3">Inputs</Title>
        </CardHeader>
        <CardContent>
          <Grid>
            <Col flex justify="center" xs={6}>
              <InputContainer
                suffix={
                  <Icon
                    color={emailFocus ? 'accent' : 'primary'}
                    icon={faEnvelope}
                  />
                }
              >
                <Input
                  fullWidth
                  type="email"
                  name="email"
                  placeholder="Email"
                  onFocus={() => setEmailFocus(true)}
                  onBlur={() => setEmailFocus(false)}
                />
              </InputContainer>
            </Col>
            <Col flex justify="center" xs={6}>
              <InputContainer
                suffix={
                  <Button
                    minimal
                    pointer
                    onClick={() => setPaswordVisible(!passwordVisible)}
                  >
                    <Icon icon={faEye} />
                  </Button>
                }
              >
                <Input
                  fullWidth
                  value="Test Password"
                  type={passwordVisible ? 'text' : 'password'}
                  placeholder="Password"
                />
              </InputContainer>
            </Col>
            <Col flex justify="center" xs={6}>
              <InputContainer
                suffix={
                  <Icon
                    color={emailFocus2 ? 'accent' : 'primary'}
                    icon={faEnvelope}
                  />
                }
                placeholder="Email"
                name="email2"
                error="Esto es un mensaje de error"
              >
                <Input
                  fullWidth
                  type="email"
                  placeholder="Email"
                  name="email2"
                  onFocus={() => setEmailFocus2(true)}
                  onBlur={() => setEmailFocus2(false)}
                />
              </InputContainer>
            </Col>
            <Col flex justify="center" xs={6}>
              <RSelect data={colourOptions} placeholder="Period" />
            </Col>
          </Grid>
        </CardContent>
      </Card>
      <Card className={inputClasses.section}>
        <CardHeader>
          <Title type="h3">Checkbox</Title>
        </CardHeader>
        <CardContent>
          <Grid gutter={20}>
            <Col flex justify="center" xs={2}>
              <CheckboxContainer
                id="privacy"
                label="Acepto privacidad"
                value="privacy"
                checked={privacy}
                onChange={setPrivacy}
              />
            </Col>
            <Col flex justify="center" xs={2}>
              <CheckboxContainer
                id="pepe"
                label="Acepto pepe"
                value="pepe"
                checked={pepe}
                onChange={setPepe}
                suffix={<Icon icon={faChevronDown} />}
              />
            </Col>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}
